// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2bFS_","icon":"SortAdornment_icon__14FGs","up":"SortAdornment_up__1Vz1R","down":"SortAdornment_down__2hrz_","active":"SortAdornment_active__11QXV"};